import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Text,
} from '@chakra-ui/react';
import { useState } from 'react';

interface ExpiredLinkCardProps {
  token: string;
  resendLink: (token: string) => Promise<void>;
  loading: boolean;
}

export const ExpiredLinkCard = ({
  token,
  resendLink,
  loading,
}: ExpiredLinkCardProps) => {
  const [sent, setSent] = useState(false);

  return (
    <Card>
      <CardHeader>
        <Text color="whiteAlpha.600" fontWeight="medium">
          Sorry, this link has expired.
        </Text>
      </CardHeader>
      <CardBody>
        <Text>
          Please click the button below to get a new link. It will be sent to
          the original shared email or phone number.
        </Text>
      </CardBody>
      <CardFooter justifyContent="flex-end">
        <Button
          isDisabled={sent}
          isLoading={loading}
          size="xs"
          onClick={() => {
            void (async () => {
              await resendLink(token);
              setSent(true);
            })();
          }}
        >
          {sent ? 'Link Sent' : 'Get New Link'}
        </Button>
      </CardFooter>
    </Card>
  );
};
